export function legacyStockListingToStockListingFragment(vehicle) {
    // Map the LegacyStockListing to a StockListingFragment
    // @ts-ignore
    const imageUrl = vehicle.images && vehicle.images.length > 0 ? vehicle.images[0].preview_url : null;
    return {
        id: vehicle.id,
        vehicle: {
            // @ts-ignore
            title: vehicle.vehicle.manufacturer.name + ' ' + vehicle.vehicle.model.name,
            // @ts-ignore
            derivative: vehicle.vehicle.derivative,
            // @ts-ignore
            colour: vehicle.vehicle.colour,
            // @ts-ignore
            type: vehicle.vehicle.vehicle_type,
            // @ts-ignore
            transmission_type: vehicle.vehicle.transmission_type,
            // @ts-ignore
            body_type: vehicle.vehicle.body_type,
            // @ts-ignore
            number_of_doors: vehicle.vehicle.number_of_doors,
            // @ts-ignore
            registration: vehicle.vehicle.registration,
            // @ts-ignore
            mileage: vehicle.vehicle.mileage,
            // @ts-ignore
            vin: vehicle.vehicle.vin,
        },
        location: {
            id: vehicle.location.id,
            name: vehicle.location.name,
            telephone: vehicle.location.primary_telephone,
            email: vehicle.location.email,
        },
        image: {
            // @ts-ignore
            url: imageUrl
        },
        meta: {
            status: {
                value: vehicle.life_cycle_status,
                label: vehicle.life_cycle_status_label
            }
        }
    };
}
